// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SitterSeoProgrammaticContent_wrapper__h25bW"};